export default __webpack_public_path__ + "0b9f292126e4a5b321f5395381db5a14.png";